//#region src/components/Theme/ThemeProvider/ThemeProvider.module.css
var e = "_themeContainer_154xh_1", t = { themeContainer: e };
//#endregion
export { t as default, e as themeContainer };
